import React from "react";
import {Route, Switch} from "react-router-dom";
import MyEximContactDetails from "./MyEximContactDetails";



const App = ({match}) => (
  <Switch>
    <Route exact path={`${match.url}`} component={MyEximContactDetails}/>
  </Switch>
);

export default App;
